/* @flow */
import StripeBankAccount from 'entities/StripeBankAccount';
import Button from 'components/Button.jsx';
import EventTrackingConstants from 'payments/constants/EventTrackingConstants';
import Money from 'payments/components/Money.jsx';
import PaymentAccountActions from 'payments/actions/PaymentAccountActions';
import Activity from 'entities/Activity';
import ActivityActions from 'payments/actions/ActivityActions';
import React from 'react';
import ToastActions from 'actions/ToastActions';
import TransactionActions from 'payments/actions/TransactionActions';

const DepositButton = React.createClass({
  propTypes: {
    activity: React.PropTypes.instanceOf(Activity).isRequired,
    account: React.PropTypes.instanceOf(StripeBankAccount).isRequired,
    amount: React.PropTypes.number.isRequired,
    onSuccess: React.PropTypes.func.isRequired,
  },

  getInitialState() {
    return {
      loading: false,
    };
  },

  render() {
    const onClick = () => {
      this.setState({ loading: true });

      const onDone = () => {
        if (this.isMounted()) {
          this.setState({ loading: false });
        }
      };

      const onError = () => ToastActions.showDefaultErrorToast();
      const reloadAccount = () => PaymentAccountActions.load();
      const reloadActivity = () => ActivityActions.loadByUuid(this.props.activity.id);

      TransactionActions
        .createWithdrawTransaction(
          this.props.activity.id,
          this.props.account.id,
          this.props.amount
        )
        .then(reloadAccount)
        .then(reloadActivity)
        .then(this.props.onSuccess, onError)
        .then(onDone, onDone);
    };

    return (
      <Button
        {...this.props}
        loading={this.state.loading}
        onClick={onClick}
        eventScreenName={EventTrackingConstants.CONFIRM_DEPOSIT}
        eventElementName="deposit">
        Deposit <Money cents={this.props.amount} />
      </Button>
    );
  },
});

export default DepositButton;



// WEBPACK FOOTER //
// ./src/payments/components/DepositButton.jsx